import { SelectAttribute } from '../../../../types/SelectAttribute';
import { Select } from '../../Select';

import styles from './FromListBirthdate.module.scss';

import type { FC, ChangeEventHandler } from 'react';

type Props = {
  birthYearAttributes: SelectAttribute[];
  birthMonthAttributes: SelectAttribute[];
  birthdayAttributes: SelectAttribute[];
  handleChangeBirthYear?: ChangeEventHandler<HTMLSelectElement>;
  handleChangeBirthMonth?: ChangeEventHandler<HTMLSelectElement>;
  handleChangeBirthday?: ChangeEventHandler<HTMLSelectElement>;
  selectedBirthYear?: string;
  selectedBirthMonth?: string;
  selectedBirthday?: string;
};

export const FromListBirthdate: FC<Props> = ({
  birthYearAttributes,
  birthMonthAttributes,
  birthdayAttributes,
  handleChangeBirthYear,
  handleChangeBirthMonth,
  handleChangeBirthday,
  selectedBirthYear,
  selectedBirthMonth,
  selectedBirthday,
}) => (
  <div>
    <span className={styles.text}>西暦</span>

    <Select
      id="birthYear"
      width="short"
      attributes={birthYearAttributes}
      onChange={handleChangeBirthYear}
      defaultValue={selectedBirthYear}
    />
    <label className={styles.text} htmlFor="birthYear">
      年
    </label>

    <Select
      id="birthMonth"
      width="short"
      attributes={birthMonthAttributes}
      onChange={handleChangeBirthMonth}
      defaultValue={selectedBirthMonth}
    />
    <label className={styles.text} htmlFor="birthMonth">
      月
    </label>

    <Select
      id="birthday"
      width="short"
      attributes={birthdayAttributes}
      onChange={handleChangeBirthday}
      defaultValue={selectedBirthday}
    />
    <label className={styles.text} htmlFor="birthday">
      日
    </label>
  </div>
);
